import { render, staticRenderFns } from "./rentInfo.vue?vue&type=template&id=5fa95862&scoped=true"
import script from "./rentInfo.vue?vue&type=script&lang=js"
export * from "./rentInfo.vue?vue&type=script&lang=js"
import style0 from "./rentInfo.vue?vue&type=style&index=0&id=5fa95862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa95862",
  null
  
)

export default component.exports